module.exports = ".not-paid {\n  color: red; }\n\n.paid {\n  color: green; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/products/products-cost-income/products-cost-income.component.scss
// module id = ./src/app/views/products/products-cost-income/products-cost-income.component.scss
// module chunks = main